<template>
    <modal-page :heading="hasResetEmailBeenSent ? 'Reset password email sent' : 'Forgot your password?'">
        <article>
            <template v-if="hasResetEmailBeenSent">
                <p class="intro">Please check your inbox.</p>
            </template>
            <template v-else>
                <p class="intro">Enter your email and we'll send you reset instructions.</p>
                <form
                    class="form grid"
                    novalidate
                    @submit.prevent="submit">
                    <div class="grid__row">
                        <div class="grid__col grid__col--100">
                            <label
                                class="reader-only"
                                for="ForgotPasswordEmail">Email Address</label>
                            <input
                                id="ForgotPasswordEmail"
                                name="ForgotPasswordEmail"
                                placeholder="Email Address"
                                type="text"
                                v-model.trim="email"
                                v-validate.disable="'required|email'"
                                :class="{ 'input--invalid': errors.has('ForgotPasswordEmail') }">
                            <span
                                class="error-message"
                                v-if="errors.has('ForgotPasswordEmail')">{{ errors.first('ForgotPasswordEmail') }}</span>
                        </div>
                    </div>
                    <div class="grid__row">
                        <div class="grid__col grid__col--100">
                            <button
                                class="submit"
                                type="submit"
                                :disabled="isSubmitting">Send Reset Link</button>
                        </div>
                    </div>
                </form>
            </template>
        </article>
    </modal-page>
</template>

<script>
import errorHandleable from '../mixins/ErrorHandleable'
import modalPage from '../components/ModalPage.vue'
import quebecUserModal from '../mixins/QuebecUserModal'
import trackable from '../mixins/Trackable'

export default {
    beforeCreate () {
        this.htmlPageTitle = `Forgot Password at ${this.$config.partnerName}`
    },
    components: {
        modalPage
    },
    created () {
        this.trackPageView(this.$route.fullPath, this.htmlPageTitle)
    },
    data () {
        return {
            hasResetEmailBeenSent: false,
            isSubmitting: false,
            email: ''
        }
    },
    head: {
        title () {
            return {
                inner: this.htmlPageTitle
            }
        }
    },
    methods: {
        submit () {
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (!isValid) { return }

                    this.isSubmitting = true

                    this.$marketplace
                        .requestPasswordReset({
                            email_address: this.email,
                            return_url: `${window.location.protocol}//${window.location.hostname}/reset-password`
                        })
                        .then(() => {
                            this.hasResetEmailBeenSent = true
                        })
                        .catch(err => this.catchAndNotify(err))
                        .finally(() => { this.isSubmitting = false })
                })
        }
    },
    mixins: [
        errorHandleable,
        quebecUserModal,
        trackable
    ]
}
</script>

<style lang="postcss" scoped>
.form {
    margin-top: 30px;
}

.intro {
    margin: 0;
    text-align: center;
}
</style>
